export const TITLE = '冠军高考专家辅导课';
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL ? process.env.VUE_APP_API_BASE_URL : '/prod-api';
export const FILE_BASE_URL = 'https://api.nssxgh.cn'; // api.nsjty.com,   api.nssxgh.cn
export const COMMON_UPLOAD_URL = "https://api.nssxgh.cn/file/upload";
export const CUSTOMER_LINK = "https://work.weixin.qq.com/kfid/kfceb1e69cd80d5aed8"; //  客服链接（企业微信）  升学规划：https://work.weixin.qq.com/kfid/kfceb1e69cd80d5aed8  广州逆熵阶梯云：https://work.weixin.qq.com/kfid/kfc086c3102d1a4df25
export const APP_VERSION = '0.1.0';
export const MAP_GD_KEY = '1cfe6807e078c7da12ff9d6a281fd863'; // 高德地图key
export const MAP_GD_SECRETKEY = '3fa6ab5f7802a694dcaa691024b7adbc'; // 高德地图秘钥
export const RECORD_COMPANY = "南京育优盟智能科技有限公司"; // 备案公司  nsjty.com   广州逆熵阶梯云文化科技有限公司  粤ICP备2025390069号-1
export const RECORD_NAME = "苏ICP备2024141451号-1"; // 备案名   //   南京育优盟智能科技有限公司   苏ICP备2024141451号-1
export const RECORD_EMAIL = "nssxgh.cn"; // 备案邮箱地址  
export const GJZY_LINK = "http://www.gjzy985.com/#/home"; // 冠军志愿网址


// 广州
// export const TITLE = '冠军高考专家辅导课';
// export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL ? process.env.VUE_APP_API_BASE_URL : '/prod-api';
// export const FILE_BASE_URL = 'https://api.nsjty.com'; // api.nsjty.com,   api.nssxgh.cn
// export const COMMON_UPLOAD_URL = "https://api.nsjty.com/file/upload";
// export const CUSTOMER_LINK = "https://work.weixin.qq.com/kfid/kfc086c3102d1a4df25"; //  客服链接（企业微信）  升学规划：https://work.weixin.qq.com/kfid/kfceb1e69cd80d5aed8  广州逆熵阶梯云：https://work.weixin.qq.com/kfid/kfc086c3102d1a4df25
// export const APP_VERSION = '0.1.0';
// export const MAP_GD_KEY = '1cfe6807e078c7da12ff9d6a281fd863'; // 高德地图key
// export const MAP_GD_SECRETKEY = '3fa6ab5f7802a694dcaa691024b7adbc'; // 高德地图秘钥
// export const RECORD_COMPANY = "广州逆熵阶梯云文化科技有限公司"; // 备案公司  nsjty.com   广州逆熵阶梯云文化科技有限公司  粤ICP备2025390069号-1
// export const RECORD_NAME = "粤ICP备2025390069号-1"; // 备案名   //   南京育优盟智能科技有限公司   苏ICP备2024141451号-1
// export const RECORD_EMAIL = "nssxgh.cn"; // 备案邮箱地址  
// export const GJZY_LINK = "http://www.gjzy985.com/#/home"; // 冠军志愿网址

// 接口超时时间配置
export const INTERFACE_TIMEOUT = 1000000;